module.exports = __webpack_public_path__ + "static/img/5.5fa45d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/5.png
// module id = S/ic
// module chunks = 0